import { render, staticRenderFns } from "./OrderSAndLConfirm.vue?vue&type=template&id=ec3ea8f6&"
import script from "./OrderSAndLConfirm.vue?vue&type=script&lang=ts&"
export * from "./OrderSAndLConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports